import ApiService from "../api";

export default class DashboardSolicitacaoService extends ApiService {

    constructor() {
        super('/api/solicitacoes/dashboard')
    }

    buscarDashboard() {
        return this.get(``)
    }
}
